export const initialState = {
	results: {
		records: 0,
		results: undefined,
	},
	competency: null,
	loading: false,
	error: false,
};
